/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Voice_Agents_TaglineInputs */

const en_svc_ai_voice_agents_tagline = /** @type {(inputs: Svc_Ai_Voice_Agents_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phone agents that answer, qualify and book, 24/7.`)
};

const ar_svc_ai_voice_agents_tagline = /** @type {(inputs: Svc_Ai_Voice_Agents_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وكلاء هاتف يردون ويؤهلون ويحجزون، على مدار الساعة.`)
};

const bn_svc_ai_voice_agents_tagline = /** @type {(inputs: Svc_Ai_Voice_Agents_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ফোন এজেন্ট যারা উত্তর দেয়, যাচাই করে আর বুকিং করে, ২৪/৭।`)
};

const de_svc_ai_voice_agents_tagline = /** @type {(inputs: Svc_Ai_Voice_Agents_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefonagenten, die annehmen, qualifizieren und buchen, rund um die Uhr.`)
};

const es_svc_ai_voice_agents_tagline = /** @type {(inputs: Svc_Ai_Voice_Agents_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agentes telefónicos que responden, califican y reservan, 24/7.`)
};

const fr_svc_ai_voice_agents_tagline = /** @type {(inputs: Svc_Ai_Voice_Agents_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des agents téléphoniques qui répondent, qualifient et réservent, 24/7.`)
};

const pt_svc_ai_voice_agents_tagline = /** @type {(inputs: Svc_Ai_Voice_Agents_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agentes telefônicos que atendem, qualificam e agendam, 24/7.`)
};

const zh_svc_ai_voice_agents_tagline = /** @type {(inputs: Svc_Ai_Voice_Agents_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全天候接听、筛选并预约的电话助手。`)
};

const tr_svc_ai_voice_agents_tagline = /** @type {(inputs: Svc_Ai_Voice_Agents_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7/24 yanıtlayan, niteleyen ve randevu alan telefon asistanları.`)
};

const ru_svc_ai_voice_agents_tagline = /** @type {(inputs: Svc_Ai_Voice_Agents_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Телефонные агенты, которые отвечают, квалифицируют и бронируют, 24/7.`)
};

const pl_svc_ai_voice_agents_tagline = /** @type {(inputs: Svc_Ai_Voice_Agents_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agenci telefoniczni, którzy odbierają, kwalifikują i rezerwują, 24/7.`)
};

/**
* | output |
* | --- |
* | "Phone agents that answer, qualify and book, 24/7." |
*
* @param {Svc_Ai_Voice_Agents_TaglineInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_voice_agents_tagline = /** @type {((inputs?: Svc_Ai_Voice_Agents_TaglineInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Voice_Agents_TaglineInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_voice_agents_tagline(inputs)
	if (locale === "bn") return bn_svc_ai_voice_agents_tagline(inputs)
	if (locale === "de") return de_svc_ai_voice_agents_tagline(inputs)
	if (locale === "es") return es_svc_ai_voice_agents_tagline(inputs)
	if (locale === "fr") return fr_svc_ai_voice_agents_tagline(inputs)
	if (locale === "pt") return pt_svc_ai_voice_agents_tagline(inputs)
	if (locale === "zh") return zh_svc_ai_voice_agents_tagline(inputs)
	if (locale === "tr") return tr_svc_ai_voice_agents_tagline(inputs)
	if (locale === "ru") return ru_svc_ai_voice_agents_tagline(inputs)
	if (locale === "pl") return pl_svc_ai_voice_agents_tagline(inputs)
	return en_svc_ai_voice_agents_tagline(inputs)
});
export { svc_ai_voice_agents_tagline as "svc_ai-voice-agents_tagline" }